<!-- I 5 esiti sono pulsanti sempre visibili; un click su quello gia'
     selezionato lo deseleziona (gestito dal genitore in setFinalDecision). -->
<div class="decision-actions-row">
  @for (status of visibleStatuses; track status.id) {
    <button
      mat-stroked-button
      type="button"
      [disabled]="survey?.is_revised"
      class="decision-action-btn"
      [class.decision-action-btn-selected]="selectedStatus?.id === status.id"
      [ngStyle]="selectedStatus?.id === status.id ? { 'background-color': status.bgcolor, 'color': 'white', 'border-color': status.bgcolor } : {}"
      (click)="onSelectDecision(status.id)"
    >
      <mat-icon>{{ status.icon }}</mat-icon>
      {{ survey?.is_revised ? status.title : status.titleNoRev }}
    </button>
  }
</div>
